import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  as?: "h2" | "h3";
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  as = "h2",
}: SectionHeadingProps) {
  const Heading = as;
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex flex-col gap-1">
        <Heading className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-5 w-1 rounded-full bg-accent-500"></span>
          {title}
        </Heading>
        {subtitle ? (
          <p className="pl-3 text-xs text-foreground-600 md:text-sm">{subtitle}</p>
        ) : null}
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      ) : null}
    </div>
  );
}